module.exports = __webpack_public_path__ + "static/media/pencil.d35ce8cf.svg";